module.exports = __webpack_public_path__ + "themify.a1ecc3b826d01251eddd.woff";


//////////////////
// WEBPACK FOOTER
// /var/www/nodejs/nextstore/src/assets/fonts/themify.woff?-fvbane
// module id = ../../../../../src/assets/fonts/themify.woff?-fvbane
// module chunks = styles